import { render, staticRenderFns } from "./ServiceProviderI18n.vue?vue&type=template&id=04686838&scoped=true"
import script from "./ServiceProviderI18n.vue?vue&type=script&lang=js"
export * from "./ServiceProviderI18n.vue?vue&type=script&lang=js"
import style0 from "./ServiceProviderI18n.vue?vue&type=style&index=0&id=04686838&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04686838",
  null
  
)

export default component.exports